import styled from 'styled-components';

const NAME_MAX_LINES = 2;

const clampLines = `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${NAME_MAX_LINES};
  overflow: hidden;
  overflow-wrap: anywhere;
`;

const ActiveWorkplace = styled.div`
  margin: 0.75rem 1rem 1rem;
  padding: 0.75rem 0.875rem;
  border: 1px solid var(--color-sidebar-border);
  border-radius: var(--radius-control);
  background: var(--color-sidebar-hover);

  .nav-sm & {
    display: none;
  }
`;

const ActiveCompanyName = styled.span`
  ${clampLines}
  color: var(--color-sidebar-text-active);
  font-weight: 600;
  line-height: 1.35;
`;

const ActiveBranchOfficeName = styled.span`
  ${clampLines}
  margin-top: 0.25rem;
  color: var(--color-sidebar-label);
  font-size: 0.8125rem;
  line-height: 1.35;
`;

const SidebarStyled = { ActiveWorkplace, ActiveCompanyName, ActiveBranchOfficeName };

export default SidebarStyled;
